<template>

    <voffice-popup-box :trigger-id="triggerId"
        class="full-xxs"
        :apply-label="applyLabel"
        @closed="onClosed">

        <table class="guestbox">

            <tr v-for="(l,what) in sections"
                class="gb-row">

                <td class="gb-td">
                    <label>{{getFieldLabel(what)}}</label>
                </td>
                <td class="gb-td">

                    <button class="btn btn-default"
                        :disabled="!canDecr(what)"
                        @click="inc(what,-1)"
                        type="button">-</button>

                </td>
                <td class="gb-td">

                    <button class="btn btn-default"
                        :disabled="!canInc(what)"
                        @click="inc(what,1)"
                        type="button">+</button>


                </td>
            </tr>
            <tr v-if="showAge && check4Children()">
                <td colspan="3"
                    class="gb-td age">
                    <label class="kids-text">{{voMsg('tpl.kidsage')}}</label>
                </td>
            </tr>
            <tr v-if="showAge && check4Children()">
                <td colspan="3"
                    class="gb-td age">

                    <input type="textbox"
                        class="form-control kids-age"
                        v-model="searchData.childrenAges">
                </td>

            </tr>
            <tr v-if="showAge">
                <td class="gb-td"
                    colspan="3"
                    v-if="!isChildrenAgeEntered()">
                    <span class="alert alert-danger warning-message"
                        vo-msg="tpl.kidsage.warning">{{voMsg('tpl.kidsage.warning')}}</span>
                </td>
            </tr>

        </table>


    </voffice-popup-box>



</template>

<script>
    import vofficePopupBox from './PopupBox.vue';
    import V from 'voUtils/V.js'

    export default {
    	voVueComponent: 'voffice-guestbox-kids',
    	components: {
    		vofficePopupBox
    	},
    	voMsgCodes: [
    		'pet.pl',
    		'adult.pl',
    		'child.pl',
    		'baby.pl'
    	],
    	props: {
    		maxValues: Object,
    		minValues: Object,
    		searchData: Object,
    		showDogCountInSearch: Boolean,
    		triggerId: String,
    		applyLabel: String,
    		childrenWelcome: Boolean,
    		petsWelcome: Boolean,
    		showAge: Boolean
    	},
    	computed: {
    		sections: function() {
    			var res = {
    				'adults': 'adult'
    			};
    			if (this.childrenWelcome) {
    				Object.assign(res, {
    					'children': 'child',
    				});
    			}
    			if (this.petsWelcome) {
    				res.petsCount = 'pet';
    			}

    			return res;

    		}
    	},
    	methods: {
    		onClosed: function() {
    			this.$emit('closed');
    		},
    		isChildrenAgeEntered: function() {
    			if ((this.searchData.children || this.searchData.babys) && !this.searchData.childrenAges) {
    				return false
    			}
    			return true;
    		},
    		check4Babys: function() {
    			//console.log('check4Babys');
    			var maxBabys = 99;
    			let el = document.querySelector("[data-unit-maxbabys]");
    			if (el) {
    				var _maxBabys = parseInt(el.getAttribute('data-unit-maxbabys'));
    				if (!isNaN(_maxBabys)) {
    					maxBabys = _maxBabys;
    				}
    			}
    			return maxBabys;
    		},
    		check4Children: function() {
    			if (this.searchData.children || this.searchData.babys) {
    				return true;
    			}
    			return false;
    		},
    		getFieldLabel: function(what) {
    			var amount = this.searchData[what] || 0;
    			return amount + ' ' + this.voMsgPl(this.sections[what] + '.pl', amount);
    		},
    		inc: function(what, step) {
    			this.searchData[what] = ((this.searchData[what] || 0) - 0) + step;
    			if (what == 'petsCount') {
    				this.searchData.pets = this.searchData[what] > 0;
    			}

    		},
    		canInc: function(what) {
    			var amount = ((this.searchData[what] || 0) - 0);
    			var max = this.maxValues && this.maxValues[what];
    			if (max != undefined && amount >= max) {
    				return false;
    			}
    			return true;
    		},
    		canDecr: function(what) {
    			var amount = ((this.searchData[what] || 0) - 0);
    			var min = this.minValues && this.minValues[what];
    			if (min == undefined) {
    				min = what == 'adults' ? 1 : 0
    			}

    			if (min != undefined && amount <= min) {
    				return false;
    			}
    			return true;
    		},

    	}

    };
</script>

<style scoped>
    .guestbox {
    	margin: 0 auto;
    	line-height: 46px;
    	text-align: left;
    	font-size: 16px;
    	color: #676767;
    	width: 295px
    }


    .gb-td {
    	padding: 8px 12px;
    }


    .gb-td.age {
    	padding: 0px 12px;
    }

    /*.age {
    	max-width: 200px;
    } */

    .age label {
    	white-space: unset;

    }

    .btn {
    	width: 48px;
    	height: 48px;
    	line-height: 1;
    	border-radius: 50%;
    	font-size: 30px;
    	padding: 4px;

    }

    .warning-message {
    	width: 100%;
    	display: block;
    	padding: 0 10px;
    	line-height: 20px;
    }

    .kids-age {
    	border: 1px solid #cccccc !important;
    	border-radius: 3px;
    	padding-left: 5px !important;
    	height: 35px;
    	width: 271px;
    }

    .kids-text {
    	font-size: 14px;
    	margin-bottom: 0px;
    }



    @media (max-width:768px) {}
</style>